/*
 * @Author: kiwi_myl
 * @Description: Do not edit
 * @Date: 2020-10-24 15:17:14
 * @LastEditTime: 2021-04-16 08:41:03
 * @FilePath: /wedsVue/visito/src/router/index.ts
 */
import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import Privacy from "../views/privacy.vue";
import Index from "../views/index.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "privacy",
    component: Privacy,
    meta:{
      title: '访客',
      keepAlive: true, 
    }
  },
  {
    path: "/home",
    name: "index",
    component: Index,
    meta:{
      title: '自主预约',
      keepAlive: true, 
    }
  },
  {
    path: "/approval",
    name: "Approval",
    component: () =>
      import(/* webpackChunkName: "approval" */ "../views/approval.vue")
  },
  {
    path: "/visit",
    name: "visit",
    component: () =>
      import(/* webpackChunkName: "visit" */ "../views/visit.vue") ,
      meta:{
        title: '访问量统计',
      }

  },
  {
    path: "/web",
    name: "web",
    component: () =>
      import(/* webpackChunkName: "web" */ "../views/web.vue") ,
      meta:{
        title: '计算器',
      }

  },
  {
    path: "/webview",
    name: "webview",
    component: () =>
      import(/* webpackChunkName: "webview" */ "../views/webview.vue") ,
      meta:{
        title: '人脸服务协议',
      }

  }

];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export default router;
